import { Moment } from "moment";
import { AppThunk, AppDispatch } from "../../types";
import fetchReport from "../../../shared/fetchReport";

type FetchFulfillmentCompletionsByUserProps = { startDate: Moment; endDate: Moment };

export type FetchFulfillmentCompletionsByUser = (
  dates: FetchFulfillmentCompletionsByUserProps,
) => void;

const fetchFulfillmentCompletionsByUser = ({
  startDate,
  endDate,
}: FetchFulfillmentCompletionsByUserProps): AppThunk => async (dispatch: AppDispatch) => {
  const params = {
    start_date: startDate.format("YYYY-MM-DD"),
    end_date: endDate.format("YYYY-MM-DD"),
  };
  await fetchReport("fulfillment_completions_by_user", dispatch, params);
};

export default fetchFulfillmentCompletionsByUser;
